import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import LeadForm from "@/components/LeadForm";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="floating-contact-btn"
        aria-label="Open contact form"
        className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-teal-600 text-white shadow-2xl flex items-center justify-center transition-all duration-200 hover:bg-teal-700 hover:-translate-y-1 hover:shadow-teal-600/50"
      >
        <MessageCircle size={24} />
      </button>
      {open && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4" data-testid="floating-contact-modal">
          <div className="absolute inset-0 bg-navy-950/60 backdrop-blur-sm" onClick={() => setOpen(false)} />
          <div className="relative w-full max-w-md rounded-t-3xl sm:rounded-3xl border border-slate-200 bg-white p-7 shadow-2xl max-h-[85vh] overflow-y-auto">
            <button
              onClick={() => setOpen(false)}
              data-testid="floating-contact-close"
              aria-label="Close contact form"
              className="absolute top-4 right-4 text-slate-400 hover:text-navy-900 transition-colors"
            >
              <X size={20} />
            </button>
            <p className="font-display font-bold text-navy-900 text-lg mb-1">Get Your Free RCM Audit</p>
            <p className="text-sm text-slate-600 mb-5">Tell us about your practice — a specialist responds within one business day.</p>
            <LeadForm type="audit" compact testIdPrefix="floating-contact-form" />
          </div>
        </div>
      )}
    </>
  );
}
